export default "__VITE_ASSET__Cl_vJ$Wu__"